import { logoStyles as styles } from "@insite/content-library/Widgets/Basic/Logo";
import { mediaQueriesBP } from "@solveindustrial/Utilities/variables";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        &&& {
            background-color: initial;
            border: none;

            ${mediaQueriesBP.maxMD} {
                display: flex;
                justify-content: center;
            }

            &::before,
            &::after {
                content: none;
            }
        }
    `,
};

styles.img = {
    ...styles.img,
    css: css`
        ${styles.img?.css}
        object-fit: contain;
    `,
};
